"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteURLFromWindowObject = getSiteURLFromWindowObject;
exports.getSiteURL = getSiteURL;
exports.getBasePathFromWindowObject = getBasePathFromWindowObject;
exports.getBasePath = getBasePath;
exports.isUrlSafe = isUrlSafe;
exports.useSafeUrl = useSafeUrl;
exports.getScheme = getScheme;
exports.isInternalURL = isInternalURL;
exports.isPermalinkURL = isPermalinkURL;
exports.getUserTypeFromUrl = getUserTypeFromUrl;
exports.isLocalhost = isLocalhost;
const constants_1 = require("constants/constants");
function getSiteURLFromWindowObject(obj) {
    let siteURL = "";
    if (obj.location.origin) {
        siteURL = obj.location.origin;
    }
    else {
        siteURL =
            obj.location.protocol + "//" + obj.location.hostname + (obj.location.port ? ":" + obj.location.port : "");
    }
    if (siteURL[siteURL.length - 1] === "/") {
        siteURL = siteURL.substring(0, siteURL.length - 1);
    }
    if (obj.basename) {
        siteURL += obj.basename;
    }
    if (siteURL[siteURL.length - 1] === "/") {
        siteURL = siteURL.substring(0, siteURL.length - 1);
    }
    return siteURL;
}
function getSiteURL() {
    return getSiteURLFromWindowObject(window);
}
function getBasePathFromWindowObject(obj) {
    return obj.basename || "";
}
function getBasePath() {
    return getBasePathFromWindowObject(window);
}
function isUrlSafe(url) {
    let unescaped;
    try {
        unescaped = decodeURIComponent(url);
    }
    catch (e) {
        unescaped = unescape(url);
    }
    unescaped = unescaped.replace(/[^\w:]/g, "").toLowerCase();
    return (!unescaped.startsWith("javascript:") && // eslint-disable-line no-script-url
        !unescaped.startsWith("vbscript:") &&
        !unescaped.startsWith("data:"));
}
function useSafeUrl(url, defaultUrl = "") {
    if (isUrlSafe(url)) {
        return url;
    }
    return defaultUrl;
}
function getScheme(url) {
    const match = /([a-z0-9+.-]+):/i.exec(url);
    return match && match[1];
}
function isInternalURL(url, siteURL) {
    return url.startsWith(siteURL || "") || url.startsWith("/");
}
// Returns true if the string passed is a permalink URL.
function isPermalinkURL(url) {
    const siteURL = getSiteURL();
    const regexp = new RegExp(`^(${siteURL})?/[a-z0-9]+([a-z\\-0-9]+|(__)?)[a-z0-9]+/pl/\\w+`, "gu");
    return isInternalURL(url, siteURL) && regexp.test(url);
}
//add
function getUserTypeFromUrl() {
    const url = getSiteURL();
    //console.log(`getUserTypeFromUrl, url=${url}`);
    /*
     * enerjetsn.hostper.com (SN)
     *enerjetrv.hostper.com (RV)
     */
    /*
     *miesn.enerjet.com.pe  (SN)
     *mierv.enerjet.com.pe   (RV)
     *miews.enerjet.com.pe  (WS)
     */
    const debugCloud = __DEBUG_CLOUD__;
    if (__DEV__) {
        if (debugCloud) {
            if (url.includes("miesn.enerjet.com.pe")) {
                return constants_1.UserType.SN;
            }
            else if (url.includes("mierv.enerjet.com.pe")) {
                return constants_1.UserType.RV;
            }
            else {
                //console.log("__USER_TYPE__", __USER_TYPE__);
                if (__USER_TYPE__ == "rv") {
                    //return UserType.RV; //esta linea es solo para pruebas en localhost, eliminar cuando se pase a producción
                    return constants_1.UserType.RV; //esta linea es solo para pruebas en localhost, eliminar cuando se pase a producción
                }
                else {
                    return constants_1.UserType.SN;
                }
            }
        }
        else {
            if (url.includes("enerjetsn.hostper.com")) {
                return constants_1.UserType.SN;
            }
            else if (url.includes("enerjetrv.hostper.com")) {
                return constants_1.UserType.RV;
            }
            else {
                //return UserType.RV; //esta linea es solo para pruebas en localhost, eliminar cuando se pase a producción
                return constants_1.UserType.RV; //esta linea es solo para pruebas en localhost, eliminar cuando se pase a producción
            }
        }
    }
    else {
        if (url.includes("mienerjet.enerjet.com.pe")) {
            //console.log("url.includes('mienerjet.enerjet.com.pe')");
            return constants_1.UserType.SN;
        }
        else if (url.includes("mienerjetrv.enerjet.com.pe")) {
            //console.log("url.includes('mienerjetrv.enerjet.com.pe')");
            return constants_1.UserType.RV;
        }
        else {
            //console.log("getUserTypeFromUrl else");
            return constants_1.UserType.SN; //esta linea es solo para pruebas en localhost, eliminar cuando se pase a producción
        }
    }
}
function isLocalhost() {
    const url = getSiteURL();
    return url.includes("localhost");
}
